<section class="contact">
  <header class="contact__header">
    <div class="contact__avatar-wrap">
      <img
        class="contact__avatar"
        [src]="contactAvatarUrl"
        width="128"
        height="128"
        [attr.alt]="'Profile photo — ' + siteOwnerName"
        loading="eager"
        decoding="async"
      />
    </div>
    <h1 class="contact__title">Contact</h1>
    <p class="contact__lead">You can reach me directly:</p>
  </header>

  <nav class="contact__actions" aria-label="Contact options">
    <a class="contact__card" [href]="'mailto:' + contactEmail">
      <span class="contact__card-label">Email</span>
      <span class="contact__card-value">{{ contactEmail }}</span>
    </a>
    <a
      class="contact__card contact__card--external"
      [href]="linkedInProfileUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span class="contact__card-label">LinkedIn</span>
      <span class="contact__card-value">Open profile<span class="contact__external-hint" aria-hidden="true"> ↗</span></span>
    </a>
  </nav>
</section>
